// Constants
export const DESKTOP_MENU_WIDTH = 280; // Width of the menu on desktop
export const DRAWER_WIDTH = 240; // Width of the drawer on mobile
export const CONDENSED_MENU_WIDTH = 72; // Width of the icon-only collapsed sidebar
